function Teacher(data) {
    this.name=data.name;
    this.picture = data.picture;
    this.description = data.description;
    this.rating=data.rating
}
export default Teacher;